/**
 * navigation-dropdown
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_navigation-dropdown.css';
import './_navigation-dropdown.twig';

// Debounce functionality.
const { debounce } = require('lodash');

export const name = 'navigation-dropdown';

export const defaults = {
  dummyClass: 'js-navigation-dropdown-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { navigationDropdown = {} }) {
  // Find our component within the DOM
  const $navigationDropdown = $('.navigation-dropdown', $context);
  // Bail if component does not exist
  if (!$navigationDropdown.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...navigationDropdown,
  };
  // An example of what could be done with this component
  $navigationDropdown.addClass(settings.dummyClass);

  // When clicking the menu trigger on mobile.
  $(document).on('click', '.nav-dropdown__menu-trigger', (e) => {
    // On mobile triggers classes.
    if (window.innerWidth < 1024) {
      e.preventDefault();
      // Toggle class to main list.
      $(e.target)
        .parents('.navigation-dropdown-header')
        .siblings('.nav-dropdown-list--main')
        .toggleClass('nav-dropdown-list--main-active');

      // Toggle class to menu trigger.
      $(e.target)
        .parents('.nav-dropdown__menu-trigger')
        .toggleClass('nav-dropdown__menu-trigger-on');

      // Toggle class to header container.
      $(e.target)
        .parents('.navigation-dropdown-header')
        .toggleClass('navigation-dropdown-header--menu-active');
    }
  });

  // When clicking the parent navigation main items on mobile.
  $(document).on('click', '.nav-dropdown-item__link', (e) => {
    // Toggle effect on items with children on mobile.
    if (
      window.innerWidth < 1024 &&
      !$(e.target).parent().hasClass('nav-dropdown-item--no-children')
    ) {
      e.preventDefault();
      $(e.target).parent().toggleClass('nav-dropdown-item--open');
    }
  });

  // When resizing, if moving between breakpoints disables all mobile changes.
  $(window).on(
    'resize',
    debounce(() => {
      // On desktop view.
      if (window.innerWidth >= 1024) {
        // Remove active class on main menu list.
        $('.navigation-dropdown-header', $navigationDropdown).removeClass(
          'navigation-dropdown-header--menu-active'
        );

        // Close menu.
        $('.nav-dropdown__menu-trigger', $navigationDropdown).removeClass(
          'nav-dropdown__menu-trigger-on'
        );

        // Remove active class on main menu list.
        $('.nav-dropdown-list--main', $navigationDropdown).removeClass(
          'nav-dropdown-list--main-active'
        );

        // Remove active class on sub lists.
        $('.nav-dropdown-item', $navigationDropdown).removeClass(
          'nav-dropdown-item--open'
        );
      }
    }, 250)
  );
}

export default enable;
